import { isDef as d } from "../utils/index.js";
import { PopupMixin as m } from "../mixins/popup/index.js";
import h from "../icon/index.js";
import { createNamespace as f } from "../utils/create/index.js";
var l = f("popup"),
  v = l[0],
  c = l[1];
var y = v({
  mixins: [m()],
  props: {
    round: Boolean,
    duration: [Number, String],
    closeable: Boolean,
    transition: String,
    safeAreaInsetBottom: Boolean,
    closeIcon: {
      type: String,
      default: "cross"
    },
    closeIconPosition: {
      type: String,
      default: "top-right"
    },
    position: {
      type: String,
      default: "center"
    },
    overlay: {
      type: Boolean,
      default: !0
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: !0
    }
  },
  beforeCreate: function beforeCreate() {
    var e = this,
      t = function t(o) {
        return function (n) {
          return e.$emit(o, n);
        };
      };
    this.onClick = t("click"), this.onOpened = t("opened"), this.onClosed = t("closed");
  },
  methods: {
    onClickCloseIcon: function onClickCloseIcon(e) {
      this.$emit("click-close-icon", e), this.close();
    }
  },
  render: function render() {
    var e,
      t = arguments[0];
    if (this.shouldRender) {
      var r = this.round,
        o = this.position,
        n = this.duration,
        s = o === "center",
        p = this.transition || (s ? "van-fade" : "van-popup-slide-" + o),
        a = {};
      if (d(n)) {
        var u = s ? "animationDuration" : "transitionDuration";
        a[u] = n + "s";
      }
      return t("transition", {
        attrs: {
          appear: this.transitionAppear,
          name: p
        },
        on: {
          afterEnter: this.onOpened,
          afterLeave: this.onClosed
        }
      }, [t("div", {
        directives: [{
          name: "show",
          value: this.value
        }],
        style: a,
        class: c((e = {
          round: r
        }, e[o] = o, e["safe-area-inset-bottom"] = this.safeAreaInsetBottom, e)),
        on: {
          click: this.onClick
        }
      }, [this.slots(), this.closeable && t(h, {
        attrs: {
          role: "button",
          tabindex: "0",
          name: this.closeIcon
        },
        class: c("close-icon", this.closeIconPosition),
        on: {
          click: this.onClickCloseIcon
        }
      })])]);
    }
  }
});
export { y as default };
